import { render, staticRenderFns } from "./PrintLabelsModal.vue?vue&type=template&id=54a45271&"
import script from "./PrintLabelsModal.vue?vue&type=script&lang=js&"
export * from "./PrintLabelsModal.vue?vue&type=script&lang=js&"
import style0 from "./PrintLabelsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports